<template>
    <div class="min-h-screen bg-white easy-footer" :style="{ 'font-family': footer.fontFamily }">
        <div
            class="min-h-full bg-white py-12 sm:py-16 lg:py-24 px-4 lg:px-6 max-w-3xl mx-auto lg:max-w-7xl"
        >
            <DocumentHeader :footer="footer" />
            <main class="">
                <div class="">
                    <div class="mb-12">
                        <h1
                            class="block text-2xl lg:text-4xl font-bold"
                            :style="{
                                color: footer.mainColor,
                            }"
                        >
                            {{ $t("r_legal.about_us") }}
                        </h1>
                    </div>
                    <div
                        :style="{ color: footer.fontColor }"
                        class="pt-8 pb-8 text-lg leading-8 whitespace-pre-line font-medium"
                        v-html="aboutContent"
                    ></div>
                </div>
            </main>
        </div>
        <FooterBody :style="{ 'font-family': footer.fontFamily }" :footer="footer" />
    </div>
</template>

<script>
import DocumentHeader from "../shared/DocumentHeader.vue";
import FooterBody from "../footers/FooterBody.vue";
import { richTextModel } from "@easy/ui/forms";

export default {
    name: "AboutBody",
    props: {
        footer: Object,
    },
    components: { FooterBody, DocumentHeader },
    computed: {
        aboutContent() {
            return richTextModel.parseToHTMLFromMarkdown(this.footer.legal.aboutContent);
        },
    },
};
</script>
